module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H. Rider Haggard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("H. Rider Haggard (1856–1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including "), _c('I', [_vm._v("She")]), _vm._v(" (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KsFTuC/tc-custom/9781504061834.jpg?1725275644789",
      "alt": "This image is the cover for the book Red Eve"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Red Eve\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A suspenseful love story set in medieval Europe from the author of the long-running Allan Quatermain series.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" First serialized in the early 1900s, this historical romance tells the story of the beautiful Eve Clavering, known as “Red Eve” for her many scarlet dresses."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Betrothed to the knight Sir Edmund Acour, Eve learns he may be a traitor to the Crown. However, her suspicions are quashed by a love potion administered to her by Acour, and the two are wed. Only Eve’s longtime lover, merchant’s son Hugh de Cressi, can save her from a bleak fate in this gripping novel set during the tumultuous reign of King Edward III."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0